import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = ({ title, subtitle }) => {
  return (
    <div className="relative py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-4xl mx-auto"
      >
        <motion.h1
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500"
        >
          {title}
        </motion.h1>
        
        {subtitle && (
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="text-xl text-gray-300 font-medium max-w-2xl mx-auto bg-slate-800/60 p-6 rounded-lg backdrop-blur-sm"
          >
            {subtitle}
          </motion.p>
        )}
      </motion.div>
    </div>
  );
};

export default HeroSection;